import { useQuery } from 'react-query';
import { useCallback } from 'react';

import { useAuth } from 'src/hooks/useAuth';

import { getAccountInfo } from 'src/utils/urls';

type AccountType = any;

async function fetchAllAccounts(
  token: string,
  tokenType: string,
): Promise<AccountType> {
  const res = await fetch(getAccountInfo, {
    method: 'GET',
    headers: {
      Authorization: `${tokenType} ${token}`,
      'Content-Type': 'application/json',
    },
  });

  if (!res.ok) {
    const text = await res.text().catch(() => '');
    throw new Error(`Failed to fetch accounts: ${res.status} ${text}`);
  }

  return res.json();
}

function useAllAccountsInfo() {
  const { token, tokenType } = useAuth();

  const fetcher = useCallback(() => {
    if (!token || !tokenType) return Promise.reject(new Error('No auth token'));
    return fetchAllAccounts(token, tokenType);
  }, [token, tokenType]);

  return useQuery<AccountType, Error>(['all_accounts'], fetcher, {
    staleTime: 5 * 60 * 1000,
    refetchOnWindowFocus: false,
    retry: 1,
  });
}

export { useAllAccountsInfo };
